module.exports = __webpack_public_path__ + "static/img/A52.3e9c09b9.jpg";